module.exports = __webpack_public_path__ + "img/driver.b6375e39.svg";